import { useContext } from 'react'

import { digObject } from '@domain-group/javascript-utils'

import { Button, ModalContext, SidebarModal } from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'

import AddCreditNoteButton from './components/AddCreditNoteButton'
import AddInvoiceButton from './components/AddInvoiceButton'
import AddPaymentButton from './components/AddPaymentButton'
import UploadBillButton from './components/UploadBillButton'

const MODAL_KEY = 'AddAccountingItemModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const AddAccountingItemModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const initCampaign = digObject(modalPayload, 'campaign', {})

  const { campaign } = useCampaign(initCampaign)

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Accounting" titleSecondLine="Item" />

      <SidebarModal.Content>
        <AddInvoiceButton campaign={campaign} />

        <AddCreditNoteButton campaign={campaign} />

        <AddPaymentButton campaign={campaign} />

        <UploadBillButton campaign={campaign} />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryUtility"
          onClick={() => closeModal()}
          size="large"
        >
          Close Modal
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <AddAccountingItemModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
